export class Permissions {
  create?: any;
  update?: any;
  delete?: any;
}
